// extracted by mini-css-extract-plugin
export default {"button":"FWJqr","button-extra":"_1mUbQ","buttonExtra":"_1mUbQ","mask":"EUFnc","wrapper":"_1RGjF","icon":"_2dCCp","label":"ZBicP"};